export default {
  MACHADALO_LOCAL_STORAGE_CREDENTIALS_KEY: 'machadalo-credentials',
  MACHADALO_LOCAL_STORAGE_TOKEN_KEY: '__md_token'
};
export const CatagoryTypes = [{ label: "MACHADALO", value: "MACHADALO" }, { label: "BUSINESS", value: "BUSINESS" }, { label: "BUSINESS_AGENCY", value: "BUSINESS_AGENCY" }, { label: "SUPPLIER_AGENCY", value: "SUPPLIER_AGENCY" }, { label: "SUPPLIER", value: "SUPPLIER" }]
